import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../../lib/api";
import SEO from "../../components/SEO";
import { PageHero } from "../../components/Bits";

export default function ReceiptVerify() {
  const { token } = useParams();
  const [v, setV] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/receipts/verify/${encodeURIComponent(token)}`)
      .then((r) => setV(r.data))
      .catch(() => setV({ valid: false }))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="bg-white" data-testid="receipt-verify-page">
      <SEO title="Verify Receipt" />
      <PageHero title="Receipt Verification" sub="Sahaj Sarathi Foundation" />
      <section className="py-14">
        <div className="container-ssf max-w-md">
          <div className="card-ssf p-8 text-center">
            {loading && <Loader2 className="mx-auto h-10 w-10 animate-spin text-saffron-600" />}
            {!loading && v?.valid && (
              <>
                <CheckCircle2 className="mx-auto h-12 w-12 text-brandgreen" strokeWidth={1.5} />
                <h1 className="mt-4 font-display text-xl font-bold text-brandgreen" data-testid="verify-valid">RECEIPT VALID</h1>
                <dl className="mt-5 space-y-2 text-left text-sm">
                  <div className="flex justify-between"><dt className="text-slate-500">Issued by</dt><dd className="font-semibold text-navy">{v.foundation}</dd></div>
                  <div className="flex justify-between"><dt className="text-slate-500">Receipt Number</dt><dd className="font-semibold text-navy" data-testid="verify-receipt-no">{v.receipt_no}</dd></div>
                  <div className="flex justify-between"><dt className="text-slate-500">Donation Date</dt><dd className="font-semibold text-navy">{v.donation_date ? new Date(v.donation_date).toLocaleDateString("en-IN") : "—"}</dd></div>
                  <div className="flex justify-between"><dt className="text-slate-500">Amount</dt><dd className="font-semibold text-navy">₹{Number(v.amount).toLocaleString("en-IN")}</dd></div>
                  <div className="flex justify-between"><dt className="text-slate-500">Payment</dt><dd className="font-bold text-brandgreen">CONFIRMED</dd></div>
                </dl>
              </>
            )}
            {!loading && !v?.valid && (
              <>
                <XCircle className="mx-auto h-12 w-12 text-red-500" strokeWidth={1.5} />
                <h1 className="mt-4 font-display text-xl font-bold text-red-600" data-testid="verify-invalid">RECEIPT INVALID</h1>
                <p className="mt-2 text-sm text-slate-500">This receipt could not be verified. It may be altered, unconfirmed, or not issued by Sahaj Sarathi Foundation.</p>
              </>
            )}
            <Link to="/" className="btn-dark mt-6 inline-flex !rounded-md !px-6 !py-2.5 text-sm" data-testid="verify-home">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
